
module.exports = function($) {

    $.fn.infiniteScrolling = function (params) {
        const args = $.extend({
            after: function ($t) {
                return;
            }
        }, params);

        const $t = $(this);
        let data = [];

        let load = true;

        if( $t.length == 0 ){
            return;
        }

        const f = {
            action: function(attr){
                load = false;

                let offset = $(args.item).length;

                $(args.loader).html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64px" height="64px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">\n' +
                    '<circle cx="50" cy="50" fill="none" stroke="#0098ac" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">\n' +
                    '<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>\n' +
                    '</circle>\n' +
                    '</svg>\n');

                $.ajax({
                    method: "POST",
                    url: WP.ajaxurl,
                    data: {
                        'action': args.action,
                        'showposts': $t.attr('data-showposts'),
                        'offset': offset,
                        'cat' : $t.attr('data-filter')
                    }
                }).done(function( msg ) {
                    $(args.loadIn).append(msg.html);
                    load = true;
                    $(args.loader).html('');
                    args.after($t);
                    if( !msg.html ){
                        $(args.loader).remove();
                    }
                })
            }
        };

        $(window).on('scroll', function(e){
            if(  $(args.loader).length ){
                offsetTop = $(args.loader).offset().top;
                if ($(window).scrollTop() + $(window).height() + 200 >= offsetTop ) {
                    if( load == true ){
                        f.action();
                    }
                }
            }
        })
    }

    $('.labels-grid').infiniteScrolling({
        'action': 'load_labels',
        'loadIn': '.labels-items',
        'item': '.label-item',
        'loader': '.infinite_scroll_loader',
        'after': function($t){
            Array.from(document.querySelectorAll('.labels-grid .label-item')).map(function(element){
                element.removeEventListener('mouseover', this);
                element.addEventListener('mouseover', function (e){
                    document.querySelector('.labels-grid .circle').style.setProperty('top', `${this.offsetTop}px`);
                    document.querySelector('.labels-grid .circle').style.setProperty('left', `${this.offsetLeft}px`);
                });
            })
        }
    })

}
